var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"relative mb-0.5 flex size-2"},[_c('span',{staticClass:"animate-custom-ping absolute inline-flex h-full w-full rounded-full bg-juniper-7 opacity-75"}),_vm._v(" "),_c('span',{staticClass:"relative inline-flex size-2 rounded-full bg-juniper-9"})])
}]

export { render, staticRenderFns }